import { MonoAction, MonoActionTypes, MonoState } from "../types/Mono";



// State
const initialState: MonoState = {
   data: {},
   loading: false,
   error: null,
   
}


export const MonoReducer = (state = initialState, action: MonoAction): MonoState => {
   switch (action.type) {
      case MonoActionTypes.FETCH_MONO:
         return { loading: true, error: null, data: {} }
      case MonoActionTypes.FETCH_MONO_SUCCESS:
         return { loading: false, error: null, data: action.payload }
      case MonoActionTypes.FETCH_MONO_ERROR:
         return { loading: false, error: action.payload, data: {} }
      default:
         return state;
   }
}